import { render, staticRenderFns } from "./aWorkDetailTaskItem.vue?vue&type=template&id=6898e80e&scoped=true"
import script from "./aWorkDetailTaskItem.vue?vue&type=script&lang=js"
export * from "./aWorkDetailTaskItem.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailTaskItem.vue?vue&type=style&index=0&id=6898e80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898e80e",
  null
  
)

export default component.exports